import { render, staticRenderFns } from "./LocalPrestacaoServico.vue?vue&type=template&id=d2e72264"
import script from "./LocalPrestacaoServico.vue?vue&type=script&lang=js"
export * from "./LocalPrestacaoServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports